import { type ChipOwnProps, Chip } from "@mui/material";
import { type FieldProps } from "react-admin";

import { useTypedFieldValue } from "@/hooks";

type Props = FieldProps;

const VALUE_TO_COLOR: Record<string, ChipOwnProps["color"]> = {
  freedom: "success",
  trial: "error",
};

export const RadiusVpnServerPrivacyTypeField = (props: Props) => {
  const value = useTypedFieldValue<string>(props) ?? "";

  return (
    <Chip
      label={value}
      color={VALUE_TO_COLOR[value] ?? "primary"}
      size="small"
    />
  );
};
